import { render, staticRenderFns } from "./ExerciciosQuestoes.vue?vue&type=template&id=90833cde&"
import script from "./ExerciciosQuestoes.vue?vue&type=script&lang=js&"
export * from "./ExerciciosQuestoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports